/* eslint-disable */
import store from "../../store/index";
import axios from "axios";
import Multiselect from "@vueform/multiselect";

export default {
  name: "ManageCountry",
  components: { Multiselect },
  props: ["countryId"],
  data() {
    return {
      baseUrl: `${process.env.VUE_APP_Service_URL}/management/country/`,
      baseapi: process.env.VUE_APP_Service_URL,
      isEditMode: false,
      allCountries: [],
      countryDetails: {},
      selectedCountryId: "",
      country: {
        countryCode: "",
        countryName: "",
        active: true,
        notes: "",
        languages: [],
        studyId: "",
        region: "",
        status: "",
        contactPerson: "",
        regulatoryAuthority: ""
      },
      selectedLanguages: [],
      defaultLanguages: "",
      countryNameError: false,
      languages: [],
      idToken: "",
      CountryStatus: [],
    };
  },
  computed: {
    isEdit() {
      return !!this.userid;
    },
  },
  mounted() {
    this.idToken = store.getters.getIdToken;
    console.log("ManageCountry countryId prop:", this.countryId);
    this.getLanguages();
    this.getAllCountryStatus();
    this.getallCountries().then(() => {
      if (this.countryId !== 0 && this.countryId !== undefined && this.countryId !== "0") {
        this.isEditMode = true;
        this.fetchCountryDetails(this.countryId);
      }
    });
    // this.getLanguages();
    // this.getallCountries();

  },
  methods: {
    async fetchCountryDetails(id) {
      try {
        this.idToken = store.getters.getIdToken;
        const response = await axios.get(
          `${this.baseUrl}getstudycountrybyid?id=${id}`,
          {
            headers: {
              Authorization: "Bearer " + this.idToken,
              "Content-Type": "application/json",
            },
          }
        );

        const data = response.data;
        if (data) {
          this.country = {
            countryName: data.countryName,
            countryCode: data.countryCode,
            active: data.active,
            notes: data.notes,
            region: data.region,
            status: data.status,
            statusDate: data.statusDate,
            owner: data.owner,
            regulatoryAuthority: data.regulatoryAuthority,
            studyId: data.studyId,
          };

          // bind selected languages (map to language codes for Multiselect)
          if (Array.isArray(data.languages) && data.languages.length > 0) {
            this.selectedLanguages = data.languages.map(l => l.code);
          } else {
            this.selectedLanguages = [];
          }

          // also select correct country in dropdown if needed
          const foundCountry = this.allCountries.find(c => c.isO_3166_CountryCode === data.countryCode);
          if (foundCountry) {
            this.selectedCountryId = foundCountry.id;
            this.onCountrySelect();
          }
        }
      } catch (error) {
        console.error("Error fetching country details:", error);
      }
    },

    clear() {
      this.country = {
        countryCode: "",
        countryName: "",
        language: "",
        region: "",
        active: true,
        owner: "",
        notes: "",
        studyId: "",
        status: "",
        statusDate: null,
        contactPerson: "",
        regulatoryAuthority: ""
      };

      this.selectedLanguages = [];
    },
    async getallCountries() {
      try {
        const idtoken = store.getters.getIdToken;
        const res = await axios.get(`${this.baseUrl}getcountrieswithlanguage`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        });
        this.allCountries = res.data;
      } catch (error) {
        console.error("Error fetching all countries:", error);
      }
    },
    async save() {
      this.countryNameError = false;
      if (!this.selectedCountryId) {
        this.countryNameError = true;
        return;
      }
      try {
        const idtoken = store.getters.getIdToken;
        const currentstudy = store.getters.getStudyIs;
        const selectedDefaultLangObj = this.languages.find(
          l => l.code === this.defaultLanguages
        );

        const payload = {
          ...this.country,
          studyId: currentstudy,
          defaultLanguage: selectedDefaultLangObj ? selectedDefaultLangObj.language : "",
          defaultLanguageCode: this.defaultLanguages || "",
          languages: (this.selectedLanguages || []).map(code => {
            const langObj = this.languages.find(l => l.code === code);
            return { language: langObj ? langObj.language : code, code };
          })
        };
        if (this.country.statusDate) {
          payload.statusDate = new Date(this.country.statusDate).toISOString();
        }

        if (this.isEditMode) {
          // Add Id for update
          payload.id = this.countryId;
          await axios.put(`${this.baseUrl}updatecountry`, payload, {
            headers: { Authorization: "Bearer " + idtoken }
          });
          alert("Country Updated Successfully");
        } else {
          await axios.post(`${this.baseUrl}createstudybasedcountry`, payload, {
            headers: { Authorization: "Bearer " + idtoken }
          });
          alert("Country Created Successfully");
        }

        this.$router.push("/StudyCountry");
      } catch (err) {
        if (err.response && err.response.data) {
          const apiError = err.response.data;

          if (apiError.errors && apiError.errors.DomainValidations) {
            alert(apiError.errors.DomainValidations[0]);
          } else if (apiError.detail) {
            alert(apiError.detail);
          } else {
            alert("An unexpected error occurred while creating country");
          }
        } else {
          alert("Unable to connect to server. Please try again later.");
        }
      }
    },

    async getLanguages() {
      try {
        const idtoken = store.getters.getIdToken;
        const res = await axios.get(`${this.baseapi}/forms/template/languages`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        });
        this.languages = res.data.map((l) => ({
          id: l.id || l.code || Math.random().toString(36).substr(2, 9),
          language: l.language,
          code: l.code,
        }));
      } catch (err) {
        console.error("Error fetching languages", err);
      }
    },
    onClosed() {
      this.$router.go(-1);
    },
    onCountrySelect() {
      const selected = this.allCountries.find(c => c.id === this.selectedCountryId);

      if (selected) {
        // Set country fields
        this.country.countryName = selected.country;
        this.country.countryCode = selected.isO_3166_CountryCode;

        // ---- Handle all available languages ----
        // If your country object has multiple languages, handle that gracefully
        const countryLangs = Array.isArray(selected.languages)
          ? selected.languages.map(l => l.toLowerCase())
          : selected.language
            ? [selected.language.toLowerCase()]
            : [];

        // Match with global language list
        const matchedLangs = this.languages
          .filter(l => countryLangs.includes(l.language.toLowerCase()))
          .map(l => l.code);

        // Bind to multiselect
        this.selectedLanguages = matchedLangs;

        // ---- Handle Default Language ----
        if (selected.defaultLanguage) {
          // Match default language from available languages list
          const defaultLangObj = this.languages.find(
            l => l.language.toLowerCase() === selected.defaultLanguage.toLowerCase()
          );
          this.defaultLanguages = defaultLangObj ? defaultLangObj.code : "";
        } else {
          // If no defaultLanguage specified, use first from matched list (optional)
          this.defaultLanguages = matchedLangs.length ? matchedLangs[0] : "";
        }
      } else {
        // Reset all fields when no country selected
        this.country.countryName = "";
        this.country.countryCode = "";
        this.selectedLanguages = [];
        this.defaultLanguages = "";
      }
    },

    async getAllCountryStatus() {
      const idtoken = store.getters.getIdToken;
      await axios
        .get(`${this.baseapi}/management/statusmaster/getall?StatusType=Country`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          this.CountryStatus = response.data

        })
        .catch((err) => {
          console.log(err);
        });
    },

  },
};